import PropTypes from 'prop-types';
import React from 'react';

import cx from 'classnames';
import { Link } from 'react-router-dom';
import dateformat from 'dateformat';
import { Row, Col } from 'react-bootstrap';
import Truncate from 'src/components/truncate';

import styles from './GroupSearchView.module.scss';
import GroupDefaultIcon from "src/legacy/images/default_group.jpg";
import DOMPurify from 'dompurify';

import { localizedStrings } from 'src/localization';

class GroupSearchView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.localizedCommons = localizedStrings.commons;
    this.localizedKeywords = localizedStrings.keywords;
  }

  render() {

    return (
      <div>
        <Link to={`/groups/${this.props.id}`} className={styles.groupLink}>
          {this._renderGroupIcon()}
        </Link>
      </div>
    );
  }

  _renderGroupIcon() {
    const group = this.props.group;

    return (
      <Row className={cx(styles.group, this.props.className)}>
        <Col md={12} className={styles.noPadding}>
          <div className={styles.groupContainer}>
            <div>

              {this.renderGroupIcon()}
            </div>
            <div className={styles.descriptionContainer}>
              <Truncate width={150}>
              <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(group.name) }}></div>
              </Truncate>
              <Col sm={12} className={cx(styles.groupMetrics, styles.noPadding)}>
                <Truncate lines={2} width={150}>
                <div className={styles.metrics}>
                  <span className={styles.label}>{this.localizedKeywords.stream}: </span>
                   {group.streamName}
                </div>
                </Truncate>
              </Col>
              <Col sm={12} className={cx(styles.author, styles.noPadding)}>
                <Truncate width={150}>{this.localizedCommons.owner}: {this.renderName(group.createdBy)}</Truncate>
              </Col>
              <Col sm={12} className={cx(styles.date, styles.noPadding, styles.italicText)}>
                <span>{this.localizedCommons.last_update}: {dateformat(group.modifiedDate, 'dd mmm yyyy')}</span>
              </Col>
            </div>

          </div>

        </Col>
      </Row>
    );
  }

  renderName(user) {
    return `${user.firstName || ''} ${user.lastName || ''}`
  }

  renderGroupIcon() {
    const group = this.props.group;
    var icon = GroupDefaultIcon;

    if (group.icon) {
      icon = group.icon.thumbnail;
    }

    let layerStyle = {
      width: this.props.iconWidth,
      height: (this.props.iconWidth * 1.1667)
    };

    let iconStyle = {
      ...layerStyle,
      'backgroundImage': `url(${icon})`,
    };

    let folderStyle = {
      height: (this.props.iconWidth * 1.1667) + 10
    };

    return (
      <div className={styles.icon}>
        <div style={folderStyle} className={styles.folder}>
          <div style={layerStyle} className={cx(styles.layer, styles.second)}>&nbsp;</div>
          <div style={iconStyle} className={cx(styles.layer, styles.cover)}>
          </div>
        </div>
      </div>
    );
  }
}
export default GroupSearchView;    